import React from 'react';
import cx from 'classnames';
import { TagV2, TagV2Size } from '@zola/zola-ui/src/components/Tag/TagV2';

import styles from './styles.module.less';

interface LetterpressTagProps {
  className?: string;
  size?: TagV2Size;
  applyEffect?: boolean;
}

export const LetterpressTag = (props: LetterpressTagProps): JSX.Element => {
  const { className, size = TagV2Size.REGULAR, applyEffect = true } = props;
  return (
    <TagV2
      size={size}
      className={cx(styles.letterpressTag, className, { [styles.letterpressEffect]: applyEffect })}
    >
      Letterpress
    </TagV2>
  );
};
